import "@visa/vds/dist/_stys/vds.min.css";
import "./styles/VSS.css";
import "./styles/VDSNav.css";
import React, { useEffect, useState } from "react";
import IdleTimer from "react-idle-timer";
import { Redirect, Route, Switch } from "react-router-dom";
import MCSOverlayLoading from "./components/MCSOverlayLoading";
import MCSTimeoutDialog from "./components/MCSTimeoutDialog";
import MCSNav from "./components/MCSWhiteNav";
import { AuthContext } from "./context/AuthContext";
import DefaultLayout from "./layout/DefaultLayout";
import AccessDenied from "./pages/Authorization/AccessDenied";
import AdminRoute from "./route/AdminRoute";
import AuthSitePublicRoute from "./route/AuthSitePublicRoute";
import AuthUserRoute from "./route/AuthUserRoute";
import PublicSiteRoute from "./route/PublicSiteRoute";
import { userService } from "./services/user.service";
import { PUBLIC_VSS_USER_ID } from "./_constants/GlobalConstants";
import { ADMIN_PAGES, AUTHENTICATED_PAGES, DENIED, HOME } from "./_constants/PageRoutes";
import { InitialiseCSRFToken } from "./_helpers/Fetch";
import { RouteHelper } from "./_helpers/RouteHelper";
import DevLoginPage from "./pages/DevLoginPage";
import axios from 'axios';

export default function App() {
    const inactivityLimit = 1000 * 60 * 10; //10mins
    axios.defaults.withCredentials = true;

    // eslint-disable-next-line no-unused-vars
    let idleTimer = null;
    const [userFetched, setUserFetched] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isVolUser, setIsVolUser] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [timeout, setTimeOut] = useState(false);
    const [publicRoutes, setPublicRoutes] = useState([]);

    const fetchData = async () => {
        const userClaims = await userService.GetClaims();
        console.log("userClaims", userClaims);
        if (userClaims != null) {
            InitialiseCSRFToken(userClaims.antiForgeryToken);
            setUserData(userClaims);
            setIsAuthenticated(true);
            let tempIsVolUser = userClaims.user && userClaims.user.volUserId !== PUBLIC_VSS_USER_ID;
            setIsVolUser(tempIsVolUser);
            setIsAdmin(userClaims.user.isAdmin);
            let temp = RouteHelper.Flattened_Public_Routes(tempIsVolUser);
            setPublicRoutes(temp);
        }
        setUserFetched(true);
    };

    useEffect(() => {
        if (process.env.REACT_APP_NODE_ENV !== "development") {
            fetchData();
        }
        if (userData == null && userFetched && !isAuthenticated) {
            window.location.href = DENIED;
        }
    }, []);

    if (process.env.REACT_APP_NODE_ENV === "development" && userData == null && !userFetched && !isAuthenticated) {
        return <DevLoginPage onLogin={fetchData}/>;
    } else if (!userFetched) {
        return <MCSOverlayLoading bgColor={"white"} opacity={1} />;
    } else if (userFetched && userData == null) {
        return (
            <DefaultLayout>
                <MCSNav />
                <AccessDenied />
            </DefaultLayout>
        );
    } else {
        return (
            <AuthContext.Provider value={{...userData, setUser: setUserData }}>
                {isVolUser && (
                    <>
                        {timeout && userData != null && (
                            <MCSTimeoutDialog
                                timeout={timeout}
                                setTimeOut={setTimeOut}
                                logOff={userService.LogOff}
                                keepAlive={userService.KeepAlive}
                            />
                        )}
                        <IdleTimer
                            ref={(ref) => {
                                idleTimer = ref;
                            }}
                            timeout={inactivityLimit}
                            onActive={handleOnActive}
                            onIdle={handleOnIdle}
                            onAction={handleOnAction}
                            debounce={250}
                            crossTab={{
                                emitOnAllTabs: true,
                            }}
                        />
                    </>
                )}

                <MCSNav />
                <Switch>
                    {/** For pages with Admin Left Navigation bar */}
                    {isAdmin &&
                        <Route
                            exact
                            path={ADMIN_PAGES}
                            render={() =>
                                <AdminRoute />
                            }
                        />
                    }
                    {/** For pages with Default Left Navigation bar */}
                    {isVolUser &&
                        <Route
                            exact
                            path={AUTHENTICATED_PAGES}
                            render={() =>
                                <AuthUserRoute />
                            }
                        />
                    }
                    {HOME !== "" ? (
                        <AuthSitePublicRoute
                            publicRoutes={publicRoutes}
                        />
                    ) : (
                        <PublicSiteRoute
                            publicRoutes={publicRoutes}
                        />
                    )}
                    <Redirect to={DENIED} />
                </Switch>
            </AuthContext.Provider>
        );
    }

    function handleOnAction(event) {
        //console.log('user did something', event)
    }

    function handleOnActive(event) {
        //console.log('user is active', event)
        //console.log('time remaining', idleTimer.getRemainingTime())
    }

    function handleOnIdle(event) {
        setTimeOut(true);
        //console.log('user is idle', event)
        //console.log('last active', this.idleTimer.getLastActiveTime())
    }
}
